<template>
  <div class="TableBox">
    <search-template page_name="MCN结算单申请" :timeMonth='timeMonth' source="mcn" @search_event='search_event'></search-template>
    <div class="operationUploadBox clear" style="margin-top:5px">
      <div class="batchDelete" style="background:#FF9B3B;border-color:#FF9B3B;" @click="clearSelection">清空选中</div>
      <div class="operationUpload">
        <div class="batchDelete" @click="applyStatement(2)">mcn结算单</div>
      </div>
      <div class="refreshIcon batchDelete" @click="init({page:1})">
        刷新
        <i class="el-icon-refresh"></i>
      </div>
      <div class="batchDelete" @click="init({page:1,exportFlag:true})">导出</div>
    </div>
    <ux-grid class="uxGridBox" ref="plxTable" :height="height" :checkboxConfig="{checkMethod: selectable, highlight: true}" @selection-change="selectionChange" @table-body-scroll="scroll" show-footer-overflow="tooltip" show-overflow="tooltip" keep-source :edit-config="{trigger: 'manual', mode: 'row'}" size="mini">
      <ux-table-column type="checkbox" align="center" fixed="left" width="40" />
      <ux-table-column v-for="item in columns" :key="item.id" :resizable="item.resizable" :field="item.prop" :title="item.label" :width="item.width" show-header-overflow='tooltip' :fixed="item.fixed" :edit-render="item.editRender?true:false" align="center" />
      <ux-table-column title="状态" align="center" minWidth="60" fixed="right" field="describe">
        <template v-slot="{ row }">
          <span v-if="row.status<3">未锁单</span>
          <div v-else>
            <span v-if="row.status==3&&row.verify_status == 0">媒介锁单</span>
            <span v-if="row.status==4&&row.verify_status == 0">财务锁单</span>
            <span v-if="row.verify_status == 1">待商务审核</span>
            <span v-if="row.verify_status == 2">商务通过</span>
            <span v-if="row.verify_status == 3">商务驳回</span>
            <span v-if="row.verify_status == 4">财务通过</span>
            <span v-if="row.verify_status == 5">财务驳回</span>
          </div>
        </template>
      </ux-table-column>
      <ux-table-column :resizable='true' title="开票状态" align="center" minWidth="60" fixed="right" field="describe">
        <template v-slot="{ row }">
          <span v-if="row.invoice_status == -2">已作废</span>
          <span v-else-if="row.invoice_status == 1">已提审</span>
          <span v-else-if="row.invoice_status == 2">商务通过</span>
          <span v-else-if="row.invoice_status == 3">商务驳回</span>
          <span v-else-if="row.invoice_status == 4">财务通过</span>
          <span v-else-if="row.invoice_status == 5">财务驳回</span>
          <span v-else-if="row.invoice_status == 6">财务撤销</span>
          <span v-else>未申请</span>
        </template>
      </ux-table-column>
      <ux-table-column :resizable='true' title="结算单状态" align="center" minWidth="60" fixed="right" field="describe">
        <template v-slot="{ row }">
          <span v-if="row.statements_status == -2">已作废</span>
          <span v-else-if="row.statements_status == -1">已保存</span>
          <span v-else-if="row.statements_status == 1">已提审</span>
          <span v-else-if="row.statements_status == 2">商务通过</span>
          <span v-else-if="row.statements_status == 3">商务驳回</span>
          <span v-else-if="row.statements_status == 4">财务通过</span>
          <span v-else-if="row.statements_status == 5">财务驳回</span>
          <span v-else>未申请</span>
        </template>
      </ux-table-column>
    </ux-grid>
    <div class="paginationBox" style="height: 30px;">
      <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" :total="total" />
    </div>
  </div>
</template>
<script>
import columnsJson from '@/components/Order/json/orderMcn.js'
import searchTemplate from '@/components/Order/searchTemplate.vue'
export default {
  components: {
    searchTemplate
  },
  data () {
    return {
      height: 0,
      columns: [],//表头
      scrollTop: 0,
      loading: false,
      timeMonth: [],
      editData: {},
      editFlag: false,
      multipleSelection: [],
      multipleSelection1: {},
      page: 1,
      page_size: 100,
      total: 0,
      search_data: [],
      selectionList: [],
      flag: false
    }
  },
  created () {
    var date = new Date();
    this.timeMonth = [date.getFullYear() + '-' + ((date.getMonth()) < 10 ? '0' + (date.getMonth()) : (date.getMonth()))];
    this.columns = columnsJson

  },
  mounted () {
    this.height = document.documentElement.clientHeight - 315 > 400 ? document.documentElement.clientHeight - 315 : 400
    this.init({ page: 1 })
  },
  methods: {
    search_event (data) {
      this.search_data = data;
      this.init({ page: 1 })
    },
    applyStatement (type) {//申请结算单
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message({
          message: '未选择订单',
          type: 'warning'
        })
        return
      }
      //判断是否是同一客户
      // var isTy = this.multipleSelection.filter((v)=>{
      //     return v.customer_name != this.multipleSelection[0].customer_name
      // })
      // if(isTy.length>0){
      //     this.$alert('请选择同一客户进行结算单申请', '提示', {
      //         dangerouslyUseHTMLString: true,
      //         confirmButtonText: '知道了',
      //         callback: action => {
      //         }
      //     });
      //     return
      // }
      var arr = [];
      this.multipleSelection.forEach((item) => {
        arr.push(item.order_id)
      });
      this.preData({ type: type, order_ids: arr, is_discount: 0 })
      // this.$confirm('请确认此结算单是否有折扣？', '提示', {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: '有折扣',
      //     cancelButtonText: '无折扣',
      //     type: 'warning'
      // }).then(() => {
      //     this.preData({type:type,order_ids:arr,is_discount:1})
      // }).catch((action) => {
      //     if(action === 'cancel'){
      //     }

      // });
    },
    preData ({ type, order_ids, is_discount }) {
      this.$loading(this.$loadingConfig);
      this.$axios.post(this.URL.BASEURL + this.URL.preData, {
        type: type,
        order_ids: order_ids,
        is_discount: is_discount
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close();
        if (res && res.errno == 0) {
          var data = res.rst;
          localStorage.setItem('statementsAddInfo' + order_ids.join('_'), JSON.stringify(data))
          if (type == 2) {//mcn结算单
            let routeData = this.$router.resolve({
              path: '/statementDetail/' + type + '?localName=' + order_ids.join('_'),
            })
            this.$winopen(routeData.href)
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close();
      })
    },
    clearSelection () {//清空选中
      this.$refs.plxTable.clearSelection();
      this.multipleSelection1 = {};
      this.multipleSelection = [];
      this.selectionList = []
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach((row, index) => {
          this.$refs.plxTable.toggleRowSelection([
            {
              row: row,
              selected: true
            }
          ])
          if (index == rows.length - 1) {
            this.flag = true
          }
        });
      }
    },
    handleCurrentChange (val) {
      this.init({ page: val, selection: 'clear' })
    },
    init ({ page, exportFlag, selection }) {
      if (!selection || selection != 'clear') {
        this.clearSelection()
      }
      var params = {
        page: page,
        page_size: this.page_size,
        month: this.timeMonth,
        is_statements: 1
      }
      if (exportFlag) {
        params.page = 1;
        params.page_size = 10000
      } else {
        page = page ? page : 1;
        params.page = page;
        this.page = page;
      }
      if (this.search_data.length == 0) {
        params.month = this.timeMonth
      } else {
        this.search_data.forEach((item) => {
          if (item.property == 'if_public' || item.property == 'is_refund') {
            params[item.property] = item.values == '是' ? 1 : null
          } else {
            params[item.property] = item.values
          }
        })
      }
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.orderMcnList, {
        params
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          var data = res.rst;
          if (exportFlag) {
            this.$exportOrder({ source: 'orderMcn', dataList: data.data, name: 'MCN机构返点表' })
          } else {
            this.total = data.pageInfo.total;
            this.datas = data.data // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
            this.$refs.plxTable.reloadData(this.datas)
            this.$nextTick(() => {
              if (this.multipleSelection1['page_' + this.page] && this.multipleSelection1['page_' + this.page].length != 0) {
                var rows = [], arr = []
                this.multipleSelection1['page_' + this.page].forEach((item) => {
                  arr.push(item.id)
                })
                rows = this.datas.filter((v) => {
                  return arr.indexOf(v.id) != -1
                })
                this.flag = false
                this.toggleSelection(rows)
              } else {
                this.flag = true
              }
            })
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    scroll ({ scrollTop, scrollLeft }) {
      this.scrollTop = scrollTop
    },
    selectable ({ row }) {//选择表格限制条件
      return row.verify_status != 1 && row.verify_status != 2 && row.statements_status != 1 && row.statements_status != 2 && row.statements_status != 4 && row.statements_status != -1
    },
    selectionChange (row) {// 选中的行
      this.selectionList = row
      if (this.flag) {
        this.multipleSelection1['page_' + this.page] = this.selectionList;
        this.multipleSelection = [];
        for (var i in this.multipleSelection1) {
          this.multipleSelection = this.multipleSelection.concat(this.multipleSelection1[i])
        }
      }
    },
  },
}
  </script>
  <style lang="scss" scoped>
@import "@/assets/css/tableStyle.scss";
.topOperation {
  display: flex;
  align-items: top;
  .screenBox {
    flex: 1;
  }
}
.TableBox {
  padding: 15px;
  background: #fff;
  margin-top: 15px;
}
.operationUpload,
.operationUploadBox {
  display: flex;
  align-items: center;
}
.operationUpload {
  flex: 1;
}
.fileTemplate {
  font-size: 12px;
  margin-right: 10px;
  text-decoration: underline;
  margin: 8px 10px 0 0;
  color: #5b7bfe;
  display: block;
}
.batchDelete {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #5b7bfe;
  background: #5b7bfe;
  color: #fff;
  margin-right: 16px;
  cursor: pointer;
  padding: 0 4px;
}
.uxGridBox {
  margin-top: 15px;
}
.refreshIcon {
  margin-right: 10px;
  background: #67c23a;
  border-color: #67c23a;
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/mcnStatement.vue